import React, { useState, useEffect, useMemo, useRef, useContext } from "react";
import { Form, Modal, Button } from "react-bootstrap";
import { Grid } from "@material-ui/core";
import { chanageBasketAction } from "../../../../redux/actions/brokerAction";
import { useDispatch, useSelector } from "react-redux";
import BasketDropDown from "../../basket/basketDropDown";
import { useToast } from "components/common/custom-toast/Toast";
import AppContext from "context/Context";

const initial = {
  BasketName: ""
};

const AddBasketModal = ({ checkedId, type, row, modalShow, setModalShow, setIsAdded }) => {
  const dispatch = useDispatch();
  const toast = useToast()
  const { config: { isDark } } = useContext(AppContext);

  const [formData, setFormData] = useState(initial);
  const [underlyingWarn, setUnderlyingWarn] = useState(null);
  const [showWarnModal, setShowWarnModal] = useState(false);

  const positions = useSelector((state) => state.orders.positions);

  useEffect(() => {
    setFormData(initial);
    setUnderlyingWarn(null);
    setShowWarnModal(false);
  }, [row]);

  // Detect underlying mismatch when basket is selected
  useEffect(() => {
    setUnderlyingWarn(null);
    if (!formData.basketId || !positions?.length) return;

    const basketPositions = positions.filter(
      (p) => p.basketId === formData.basketId && p.id !== row?.id
    );
    if (basketPositions.length === 0) return;

    const basketUnderlyings = new Set(
      basketPositions.map((p) => p.instrument?.name).filter(Boolean)
    );
    if (basketUnderlyings.size !== 1) return;

    const basketUnderlying = [...basketUnderlyings][0];
    const incomingUnderlying = row?.instrument?.name;

    if (incomingUnderlying && incomingUnderlying !== basketUnderlying) {
      setUnderlyingWarn(
        `This basket's positions are all on "${basketUnderlying}". Moving "${incomingUnderlying}" here will wipe the basket's Underlying-based RMS.`
      );
    }
  }, [formData.basketId, positions, row]);

  const dispatchAdd = () => {
    const params = {
      "basketId": formData.basketId,
      "basketName": formData.BasketName,
      "clearSlTp": true,
      "positionIds": checkedId
    };
    dispatch(chanageBasketAction(params)).then((data) => {
      if (data.status) {
        toast.success("Basket added successfully");
        setIsAdded(true);
      } else {
        toast.error("Something went wrong");
        setIsAdded(false);
      }
      setModalShow(false);
      setShowWarnModal(false);
    }).catch((err) => {
      console.log("errerr", err);
      toast.error("Something went wrong");
    });
  };

  const AddBasket = () => {
    if (underlyingWarn) {
      setShowWarnModal(true);
      return;
    }
    dispatchAdd();
  };

  return (
    <>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="add-strategy"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Add to Strategy</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Grid item id="area">
            <BasketDropDown formData={formData} setFormData={setFormData} />
          </Grid>
        </Modal.Body>
        <Modal.Footer>
          <Button
            disabled={!formData.BasketName}
            onClick={() => AddBasket()}
          >
            Add
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Confirmation modal for Underlying RMS wipe warning */}
      <Modal
        show={showWarnModal}
        onHide={() => setShowWarnModal(false)}
        size="sm"
        centered
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title style={{ fontSize: '15px' }}>
            Underlying RMS Warning
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: '13px' }}>
          <p className="mb-2">{underlyingWarn}</p>
          <p className="mb-0" style={{ color: isDark ? '#9ca3af' : '#666' }}>
            The basket's Underlying-based RMS will be cleared. Do you want to proceed?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" size="sm" onClick={() => setShowWarnModal(false)}>
            Cancel
          </Button>
          <Button variant="warning" size="sm" onClick={dispatchAdd}>
            Proceed
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AddBasketModal;
